import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

// Handles the redirect from Emergent Auth: URL contains #session_id=...
// Exchanges it for our backend session, then navigates to /dashboard (or /admin).
export const AuthCallback = () => {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const run = async () => {
      const hash = window.location.hash || "";
      const match = hash.match(/session_id=([^&]+)/);
      const sessionId = match ? decodeURIComponent(match[1]) : null;
      if (!sessionId) {
        setError("Missing session id.");
        setTimeout(() => navigate("/login", { replace: true }), 1500);
        return;
      }

      try {
        const { data } = await api.post("/auth/session", null, {
          headers: { "X-Session-ID": sessionId },
        });
        setUser(data);
        // Clean hash from URL
        window.history.replaceState({}, "", window.location.pathname);
        const target = data.role === "admin" ? "/boxbquote" : "/dashboard";
        navigate(target, { replace: true, state: { user: data } });
      } catch (e) {
        setError(e?.response?.data?.detail || "Sign-in failed. Please try again.");
        setTimeout(() => navigate("/login", { replace: true }), 1800);
      }
    };
    run();
  }, [navigate, setUser]);

  return (
    <div data-testid="auth-callback" className="min-h-screen flex items-center justify-center bg-white">
      <div className="text-center">
        <Loader2 className="h-8 w-8 text-[#0A192F] animate-spin mx-auto" />
        <p className="mt-4 text-slate-600 font-medium">Signing you in…</p>
        {error && <p data-testid="auth-callback-error" className="mt-3 text-sm text-red-600">{error}</p>}
      </div>
    </div>
  );
};
